import { rootApi } from '../../../../app/stores/baseQuery';
import { TaskInListDto, TaskListDto } from '../../../../shared/model/tasks/types';

export const tasksApi = rootApi.enhanceEndpoints({ addTagTypes: ['TaskList'] }).injectEndpoints({
  endpoints: (builder) => ({
    getTaskList: builder.query<TaskInListDto[], void>({
      query: () => ({
        url: 'getarraysubjects',
      }),
      providesTags: () => ['TaskList'],
      transformResponse: (result: TaskListDto): TaskInListDto[] => {
        return result.GetArraySubjectsResult.data.ArraySubjects;
      },
      transformErrorResponse(error) {
        console.error('getarraysubjects: ', error);
        return error;
      },
    }),
  }),
});

export const { useGetTaskListQuery } = tasksApi;
